import { createContext, useContext, type ReactNode } from "react";
import type { ModuleContext } from "../contracts/module";

const ModuleContextReact = createContext<ModuleContext | null>(null);
ModuleContextReact.displayName = "ModuleContext";

/**
 * Provido AUTOMATICAMENTE pelo kernel em volta das rotas de cada módulo.
 * Módulos não precisam mais do `src/app/context.tsx` repetido em cada
 * pacote do CadFrn.
 */
export function ModuleContextProvider({
  value,
  children,
}: {
  value: ModuleContext;
  children: ReactNode;
}) {
  return <ModuleContextReact.Provider value={value}>{children}</ModuleContextReact.Provider>;
}

export function useModuleContext(): ModuleContext {
  const ctx = useContext(ModuleContextReact);
  if (!ctx) {
    throw new Error("useModuleContext() precisa estar dentro de um módulo carregado pelo kernel.");
  }
  return ctx;
}
